;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="777d6a3b-4a6c-4650-b43e-43e9bb783259",e._sentryDebugIdIdentifier="sentry-dbid-777d6a3b-4a6c-4650-b43e-43e9bb783259")}catch(e){}}();import React__default, { useContext } from 'react';
import AppContext from '../../context/AppContext.js';
import styles from './Multilanguage.module.scss.js';
import '../../_virtual/_sentry-release-injection-file.js';

function getLanguageWithFlags(availableLanguages, contentCDN) {
    return availableLanguages.map(({ selected, locale }) => {
        const lang = locale.split('-')[0];
        return {
            url: `${contentCDN}/media/ui-components/v6-latest/png/country-flags/1x1/${lang}.png`,
            label: lang.toUpperCase(),
            selected,
            locale,
        };
    });
}
function LanguageWithFlag({ url, label }) {
    const { translations } = useContext(AppContext);
    const accessibleText = translations
        .get('shop.header.multilanguage.accessible.text')
        ?.replace('${language}', label);
    return (React__default.createElement("div", { className: styles.languageFlag, "data-zta": "language-flag" },
        React__default.createElement("span", { className: styles.languageFlagLabel, "data-zta": "language-label" }, label),
        React__default.createElement("img", { "data-zta": "language-flag-image", className: styles.languageFlagImage, src: url, width: "16", alt: accessibleText })));
}

export { LanguageWithFlag, getLanguageWithFlags };
//# sourceMappingURL=LanguageWithFlag.js.map
